import { useGame } from '@0g/react';
import * as React from 'react';
import { MenuArrow, MenuContent, MenuItem, MenuLabel, MenuRoot, MenuTrigger, } from './components/Menu';
export function AddComponentButton(_a) {
    var entityId = _a.entityId;
    var game = useGame();
    var addComponent = function (C) {
        game.add(entityId, new C());
    };
    return (React.createElement(MenuRoot, null,
        React.createElement(MenuTrigger, null, "Add Component"),
        React.createElement(MenuContent, null,
            React.createElement(MenuLabel, null, "Component Type"),
            game.componentManager.componentTypes.map(function (Type) { return (React.createElement(MenuItem, { key: Type.id, onClick: function () { return addComponent(Type); } }, Type.name)); }),
            React.createElement(MenuArrow, null))));
}
//# sourceMappingURL=AddComponentButton.js.map